import './teams.js';

import LoadingLogo from '../../../../components/loadingLogo/loadingLogo';

export default function Teams() {
    return (
        <div className="no-access">
                        <LoadingLogo/>
                        <p style={{ color: 'red' }}>Feature not ready yet but will be coming Soon!</p>
                      </div>
    )
}